import { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { CommSettingsValue, EventRuleValue } from "./types";
import EventRule from "./EventRule";
import { TemplateItemProps } from "../types";
import TitledCard from "../TitledCard";

interface CommSettingsProps extends TemplateItemProps<CommSettingsValue> {}

const CommSettings = ({ value, saved, onChange, disabled }: CommSettingsProps) => {
  const [warn, setWarn] = useState(value.warn);
  const [alarm, setAlarm] = useState(value.alarm);

  const { formatMessage } = useIntl();

  const onWarnChange = useCallback(
    (warn: EventRuleValue) => {
      value.warn = warn;
      onChange(value);
    },
    [value, onChange]
  );

  const onAlarmChange = useCallback(
    (alarm: EventRuleValue) => {
      value.alarm = alarm;
      onChange(value);
    },
    [value, onChange]
  );

  useEffect(() => {
    setWarn(value.warn);
    setAlarm(value.alarm);
  }, [value]);

  return (
    <TitledCard title={formatMessage({ defaultMessage: "Communication" })}>
      <Grid container spacing={1} padding={1}>
        <Grid item xs={12}>
          <EventRule
            title={formatMessage({ defaultMessage: "Warning" })}
            value={warn}
            saved={saved?.warn || null}
            onChange={onWarnChange}
            disabled={disabled}
            timeValue
          />
        </Grid>
        <Grid item xs={12}>
          <EventRule
            title={formatMessage({ defaultMessage: "Alarm" })}
            value={alarm}
            saved={saved?.alarm || null}
            onChange={onAlarmChange}
            disabled={disabled}
            timeValue
          />
        </Grid>
      </Grid>
    </TitledCard>
  );
};

export default CommSettings;
